import React, { Component } from 'react'
import { Button, Form, Table, Input, Row, Col, Modal, DatePicker, Drawer, Icon, Avatar } from 'antd'
import {Link} from 'react-router-dom'
import moment from 'moment'

import { reviseMerchantType, getReturnDetailStatus, getUserList } from '_src/api/api'

import PrevImg from '_src/components/PrevImg/PrevImg'
import '_src/common/style/common.less' 


const { RangePicker } = DatePicker

const { Search } = Input

const { confirm } = Modal
@Form.create({ name: '' })
class ReturnForm extends Component {
  constructor (props) {
    super(props)
    this.id = '' // 选中商户ID
    // 参数集合
    this.param = {
      mobile: '', // 服务单号
      pageNum: 0,
      createStart: '',
      createEnd: '',
      totalElements: 0
    }
    this.state = {
      merchant: {},
      loading: true,
      visible: false,
      dataList: [],
      statusBtns: [],
    }
  }

  componentDidMount () {
    this.loadData()
    getReturnDetailStatus()
      .then(res=>{
        const { data } = res
        const arr = data.map(item=>{
          item.status = item.status === '总数'? '' : item.status
          return {text: item.status, num: item.count, id: item.status}
        })
        this.setState({
          statusBtns: arr
        })
      })
  }
  loadData () {
    this.setState({loading: true})
    const { pageNum, serviceNum, mobile, createAt, createStart, createEnd } = this.param
    const { status } = this.state
    let param = {pageNum, status, pageSize: 10}
    if (!!serviceNum) {
      param = {...param, serviceNum}
    }
    if (!!mobile) {
      param = {...param, mobile}
    }
    if (!!createAt) {
      param = {...param, createAt}
    }
    if (!!createStart&&!!createEnd) {
      param = {...param, createStart, createEnd}
    }
    // 获取列表信息
    getUserList(param)
      .then(res=>{
        const { data } = res
        this.param.totalElements = data.totalElements
        const dataList = data.content.map(item=>{
          return {...item, key: item.id, id: item.id}
        })
        this.setState({
          dataList: dataList,
          loading: false,
          visible: false
        })
      })
  }
  
  columns = () => {
    return [
      {
        title: <span>用户ID</span>,
        align: 'center',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: <span>用户头像</span>,
        align: 'center',
        dataIndex: 'avatar',
        key: 'avatar',
        render: (url)=>(
          <div>
            {url
              ?<img style = {{width: 40}} src = {url} alt = "头像" onClick={()=>this.PrevImg.show(url)} />
              : <Avatar size={35} shape="square" icon="user" />
            }

          </div>
        )
      },
      {
        title: <span>用户账号</span>,
        align: 'center',
        dataIndex: 'mobile',
      },

      {
        title: <span>用户昵称</span>,
        align: 'center',
        dataIndex: 'nickname',
      },
      {
        title: <span>用户积分</span>,
        align: 'center',
        dataIndex: 'integral',
      },     

      {
        title: <span>操作</span>,
        align: 'center',
        render: item => <div className = "table_btn">
          <Link to={{ pathname: '/user/detail?id=' + item.id }} target="_blank" style={{marginRight: 10}}><Button type="primary" icon="eye">查看</Button></Link>
        </div>,
      },
    ]
  }

  // 商家状态切换
  handleSwitch = (checked, index) => {
    const _self = this
    const { dataList } = this.state
    const list = [...dataList]
    const { merchantName, id } = list[index]
    confirm({
      title: '温馨提示',
      content: (
        <p>你确定要将
          <strong style = {{color: '#000'}}> {merchantName}</strong> 切换至 <strong style = {{color: 'red'}}>{checked?'有效':'无效'}</strong> 吗？
        </p>),
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk () {
        reviseMerchantType(id)
          .then(()=>{
            list[index].status = checked
            _self.setState(()=>({
              dataList: list
            }))
          })
      },
      onCancel () {
      },
    })
  }
  // 关闭抽屉
  onClose = () => {
    this.setState({
      visible: false
    })
  }

  // 打开抽屉
  /**
   * @param{type:1->查看,2->修改，3->添加}
  */
  openDrawer = (record) => {
    debugger
    record= record || {}
    this.setState(()=>({
      visible: true,
      merchant: record
    }), ()=>{
    })
  }
  // 搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }
  // 时间搜索
  handleDateSearch = (key, _, dateString) => {
    this.param[key] = dateString
    this.param.pageNum = 0
    this.loadData()
  }
  timerChange = (e) => {
    this.param.pageNum = 0
    
    this.param.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
    this.param.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    
  
    this.loadData()
  }
  linkTo (url) {
    this.props.history.push(url)
  }
  // 状态按钮搜索
  handleBtnSearch = (status) => {
    this.setState({
      status
    }, ()=>{
      this.param.pageNum = 0
     
      this.loadData()
    })
  }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, loading, visible, merchant } = this.state
    const { merchantName } = merchant
    const { pageNum, totalElements } = this.param
    // const statusBtns = [
    //   {text: '全部申请', num: this.totalElements},
    //   {text: '待处理', num: this.totalElements},
    //   {text: '退货中', num: this.totalElements},
    //   {text: '已完成', num: this.totalElements},
    //   {text: '已拒绝', num: this.totalElements},
    // ]

    const drawerHeader = (
      <div className = "page_top">
        <p className = "page_top_title">
          修改商户-<span style = {{color: 'red'}}>{merchantName}</span>
        </p>
        <div className = "returnDetail_btn">
          <Button className = "" type="primary" onClick = {this.onClose}>
            <Icon type="left" />
            返回
          </Button>
        </div>
      </div>
    )
    return (
      <div className = "ReturnForm page_content" style={{padding: 20}}>
        {/* <div className = "top" >
          {
            statusBtns.map((item, index)=>(
              <SearchButton key = {index} id = {item.id} state = {status} handleSearch = {this.handleBtnSearch} label = {item} />
            ))
          }
          
        </div> */}
        <PrevImg ref={el => this.PrevImg = el} />
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "手机号">
                  <Search placeholder="请输入手机号" onSearch={(v)=>{ this.handleSearch('mobile', v) }}enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "注册时间">
                  <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Drawer
          title={drawerHeader}
          width={'800'}
          onClose={this.onClose}
          destroyOnClose
          closable = {false}
          visible = {visible}
        />
      </div>
    )
  }
}
export default ReturnForm